import React, { useEffect } from "react";
import About from "./Comopnents/About";
import Eduaction from "./Comopnents/Education";
import ScrollButton from "./Comopnents/Genral/scrollButton";
import Home from "./Comopnents/Home";
import Project from "./Comopnents/Project";
import Skills from "./Comopnents/Skills";
import Experince from "./Comopnents/Experince";
import Certificate from "./Comopnents/Certificate/certificate";
import Foot from "./Comopnents/Footer/footer";
import Swal from "sweetalert2";
import './main.css'


function Main() {
    useEffect(() => {
      Swal.fire({
        title: 'Notice',
        text: 'This is my old portfolio. Check out my new portfolio or stay here.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Go to New Portfolio',
        cancelButtonText: 'Stay Here',
        customClass: {
          popup: 'custom-popup',
          title: 'custom-title',
          content: 'custom-content',
          confirmButton: 'custom-confirm-button',
          cancelButton: 'custom-cancel-button'
        },
        buttonsStyling: false // Disable default button styling
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = 'https://krushnanagare.vercel.app/';
        } else if (result.isDismissed) {
          console.log('User chose to stay on the old portfolio.');
        }
      });
    }, []);
  return (
    <div>

    
      <Home />
      <About />
      <Skills />
      <Eduaction />
      <Project />
      <Experince />
      <ScrollButton />
      <Certificate />
      <Foot />
    </div>
  );
}

export default Main;
